import { typedI18nFactory } from 'utils/typedI18nFactory';

import { AllServiceStatuses } from '../ServiceState.types';

import { en } from './en';
import { ru } from './ru';

export const i18nServiceState: I18nFunction<AllServiceStatuses> = typedI18nFactory({ ru, en });
